import { analytics } from 'moet-core';

export const ANALYTICS_EVENTS = {
  basicInfo: new analytics.Event({
    name: 'Basic info submitted',
    description: 'Merchant submits basic information',
    action: analytics.EVENT_ACTION.CTA_CLICK,
    category: analytics.EVENT_CATEGORY.FLOW_STEP,
    type: analytics.EVENT_TYPE.USER_PREFERENCE,
    properties: ['email', 'website', 'country'],
    userAttributes: ['email', 'website', 'country', 'utmFriendbuy'],
  }),
  notABusinessLink: new analytics.Event({
    name: 'Not A Business Link Clicked',
    description: 'Merchant clicks link to learn about if not a business',
    action: analytics.EVENT_ACTION.CTA_CLICK,
    category: analytics.EVENT_CATEGORY.CHANGE_REGION,
    type: analytics.EVENT_TYPE.USER_PREFERENCE,
    properties: ['notABusinessLink'],
  }),
};
